// These are also in sizes.scss
// We could use :export in the SCSS file but that locks us into sass-loader + webpack
// for little gain
export const desktopWidth = 960
export const largeDesktopWidth = 1136
